import { SvgIcon, SvgIconProps } from './SvgIcon';

export const LightModeIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      {/* Outlined center ring: outer r=3.75, inner r=2.25, centered at (10,10). */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25ZM7.75 10C7.75 8.75736 8.75736 7.75 10 7.75C11.2426 7.75 12.25 8.75736 12.25 10C12.25 11.2426 11.2426 12.25 10 12.25C8.75736 12.25 7.75 11.2426 7.75 10Z"
        fill="currentColor"
      />
      {/* 8 rays: 1.5-wide rounded stroke-as-fill bars, radiating every 45deg. */}
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
        <rect
          key={angle}
          x={9.25}
          y={2.25}
          width={1.5}
          height={2.75}
          rx={0.75}
          fill="currentColor"
          transform={`rotate(${angle} 10 10)`}
        />
      ))}
    </SvgIcon>
  );
};
